import { render, staticRenderFns } from "./people-filter-yq.vue?vue&type=template&id=51ca309b&scoped=true"
import script from "./people-filter-yq.vue?vue&type=script&lang=js"
export * from "./people-filter-yq.vue?vue&type=script&lang=js"
import style0 from "./people-filter-yq.vue?vue&type=style&index=0&id=51ca309b&prod&lang=scss&scoped=true"
import style1 from "./people-filter-yq.vue?vue&type=style&index=1&id=51ca309b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ca309b",
  null
  
)

export default component.exports